import { Route, Routes} from 'react-router-dom';
import { useState, useEffect } from 'react';
import Landing from './components/Landing-component/Landing';
import Home from './components/Home-component/Home';
import Detail from './components/Detail-component/Detail';
import Form from './components/Form-component/Form';
import Wip from './components/Layout-components/WorkInProgress/Wip';

function App() {
  const [showToast, setShowToast] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setShowToast(false), 6000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="App">
      {showToast && (
        <div className="viewport-toast">
          <span>⚠️</span>
          <span>Para una mejor experiencia, se recomienda una resolución de <strong>1920 × 1080</strong></span>
          <button onClick={() => setShowToast(false)}>✕</button>
        </div>
      )}
        <Routes>
          <Route path="/" element={<Landing />}/>
          <Route path="/home" element={<Home />}/>
          <Route path='/detail/:id' element={<Detail />} />
          <Route path='/createGame' element={<Form />} />
          <Route path="/workinprogress" element={<Wip />}/>
        </Routes>
    </div>
  );
}

export default App;